const DEFAULT_ERROR_CODE = '0500'

const getErrorCode = (err) => err?.errorCode ? err.errorCode : DEFAULT_ERROR_CODE

export default getErrorCode
